import initialState from './initialState';
import { types } from '../actions/notificationActions';
import { NotificationModel, NotificationTypes } from '../models/NotificationModel';

export default function notificationsReducer(state = initialState.notifications, action) {
  switch (action.type) {
    case types.SHOW_ERROR_NOTIFICATION: {
      return [...state, new NotificationModel(action.message, NotificationTypes.error)];
    }
    case types.SHOW_SUCCESS_NOTIFICATION: {
      return [...state, new NotificationModel(action.message, NotificationTypes.success)];
    }
    case types.CLEAR_NOTIFICATIONS:
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notificationsReducer.js